/**
 * Shared Naturals guest-flow viewport queries.
 *
 * Android tablet WebViews often report landscape widths > 1024px and would
 * otherwise fall into "desktop" CSS. Treat coarse-pointer / no-hover devices
 * up to 1366px as tablet/shell so portrait + landscape stay consistent.
 */

export const COMPACT_SHELL_MAX_PX = 1024;
export const TOUCH_TABLET_MAX_PX = 1366;

/** Phones + tablets, including large Android landscape WebViews. */
export const SHELL_MQ = [
  `(max-width: ${COMPACT_SHELL_MAX_PX}px)`,
  `(max-width: ${TOUCH_TABLET_MAX_PX}px) and (pointer: coarse) and (hover: none)`,
].join(', ');

/** Mid-size tablet band (two-column guest layouts). */
export const TABLET_BAND_MQ = [
  `(min-width: 768px) and (max-width: ${COMPACT_SHELL_MAX_PX}px)`,
  `(min-width: 768px) and (max-width: ${TOUCH_TABLET_MAX_PX}px) and (pointer: coarse) and (hover: none)`,
].join(', ');

/** Desktop landscape used by some salon landing animations. */
export const DESKTOP_LANDSCAPE_MQ =
  `(min-width: ${COMPACT_SHELL_MAX_PX + 1}px) and (orientation: landscape) and (hover: hover), ` +
  `(min-width: ${TOUCH_TABLET_MAX_PX + 1}px) and (orientation: landscape)`;

export function matchesShellViewport(win = typeof window !== 'undefined' ? window : null) {
  if (!win?.matchMedia) return false;
  return win.matchMedia(SHELL_MQ).matches;
}

export function matchesTabletBand(win = typeof window !== 'undefined' ? window : null) {
  if (!win?.matchMedia) return false;
  return win.matchMedia(TABLET_BAND_MQ).matches;
}
